import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {Component, computed, watch} from 'vue';
import {
    isUserTab,
    IWidgetTabParams,
    TAB_TYPE_FORM,
    TAB_TYPE_HTML,
    TAB_TYPE_PAYMENT,
    TAB_TYPE_REVIEWS
} from "~/chat/ts/data/ITab";
import {WidgetStore} from "~/chat/ts/store/Widget";
import HtmlContent from "~/chat/vue/widget/tabs/html/HtmlContent.vue";
import FormContent from "~/chat/vue/widget/tabs/form/FormContent.vue";
import ReviewsTabContent from "~/chat/vue/widget/tabs/reviews/ReviewsTabContent.vue";
import PaymentFormContent from "~/chat/vue/widget/tabs/payment/PaymentFormContent.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {OFFLINE_FORM_TAB_ID} from "~/chat/ts/Constants";
import OfflineFormTabContent from "~/chat/vue/widget/tabs/chat/OfflineFormTabContent.vue";
import AnalyticCounters from "~/chat/ts/service/AnalyticCounters";


const __default__ = {
    name: "ContentTabInner"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tab: {}
  },
  emits: ["scroll-to"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;


watch(computed(() => props.tab.id), () => {
    if (isUserTab(props.tab.type)) {
        AnalyticCounters.send(`Tab display ${props.tab.id}`, `Tab display: ${props.tab.title}`);
    }
}, {
    immediate: true
});
AnalyticCounters

let tabComponent = computed<Component>(() => {
    let type = props.tab.type;
    if (props.tab.id == OFFLINE_FORM_TAB_ID) {
        return OfflineFormTabContent;
    } else if (type == TAB_TYPE_HTML) {
        return HtmlContent;
    } else if (type == TAB_TYPE_FORM) {
        return FormContent;
    } else if (type == TAB_TYPE_REVIEWS) {
        return ReviewsTabContent;
    } else if (type == TAB_TYPE_PAYMENT) {
        return PaymentFormContent;
    }
    return null;
});

let tabParamsFromOperator = computed(() => {
    let params = WidgetStore.tabParamsFromOperator.value[props.tab.id];
    if (params && ObjectHelper.hasKeys(params)) {
        return params;
    }
    return null;
});

let tabKey = computed(() => {
    let key = props.tab.id;
    let params = tabParamsFromOperator.value;
    if (params) {
        key = JSON.stringify(params);
    }
    return key;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tabComponent)), {
    class: _normalizeClass(`tab_${_ctx.tab.id}`),
    key: _unref(tabKey),
    "params-from-operator": _unref(tabParamsFromOperator),
    tab: _ctx.tab,
    onScrollTo: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('scroll-to', $event)))
  }, null, 40, ["class", "params-from-operator", "tab"]))
}
}

})